import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NotificationManager } from "react-notifications";
import "./style.css";
import Layout from "../layout";
import mac from "../../assets/images/home/mac.png";
import playstation from "../../assets/images/home/playstation.png";
import { cmsInstance } from "../../axios/axiosconfig";
import ContentBox from "../common/ContentBox";

function ResponsibleGaming() {
  const { i18n } = useTranslation();
  const [pageContent, setPageContent] = useState({});

  const getContent = async () => {
    try {
      const page = "/responsiblegaming";
      const { language } = i18n;
      const {
        data: { content, msg },
        status,
      } = await cmsInstance.get(`/content${page}/${language}`);
      if (status === 200) {
        setPageContent(content);
      } else {
        NotificationManager.error(msg, "Message", 10000);
      }
    } catch (error) {
      console.error("Error", error.message);
    }
  };

  const onLanguageChanged = () => {
    getContent();
  };
  useEffect(() => {
    getContent();
    i18n.on("languageChanged", onLanguageChanged);
  }, []);

  return (
    <Layout>
      <div className="default-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="title-page responsible-title">
                <ul className="breadcrum">
                  <li>
                    <Link to="/">{pageContent.home}</Link>
                  </li>
                  <li>{pageContent.responsible_gaming}</li>
                </ul>
                <h2>{pageContent.responsible_gaming}</h2>
              </div>
            </div>
          </div>
          <ContentBox
            header={pageContent.responsible_gaming}
            paragraph={pageContent.para2}
            imageSrc={mac}
          />
          <ContentBox
            header={pageContent.responsible_gaming}
            paragraph={pageContent.para3}
            imageSrc={playstation}
            reversed
          />
        </div>
      </div>
    </Layout>
  );
}

export default ResponsibleGaming;
